var map = {
	".": 72812,
	"./": 72812,
	"./App": 7708,
	"./App.css": 44050,
	"./App.js": 7708,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./HelpScreen": 95869,
	"./HelpScreen.js": 95869,
	"./HighlightEmbed": 75396,
	"./HighlightEmbed.js": 75396,
	"./MinimalTextField": 62584,
	"./MinimalTextField.js": 62584,
	"./NeighborhoodsVisualization": 88345,
	"./NeighborhoodsVisualization.js": 88345,
	"./PlayPauseButton": 20980,
	"./PlayPauseButton.js": 20980,
	"./SquishedVisualization": 2816,
	"./SquishedVisualization.js": 2816,
	"./config": 93488,
	"./config.js": 93488,
	"./data/rtfc-highlights": 47675,
	"./data/rtfc-highlights-small": 79589,
	"./data/rtfc-highlights-small.json": 79589,
	"./data/rtfc-highlights.json": 47675,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./utils": 13829,
	"./utils.js": 13829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;